import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';

import { createReducer } from './reducers/index';
import { trackingMiddleware } from './tracking-middleware';
import { CalculatorInitialState } from 'apps/calculator/types';

export const createCalculatorStore = ({
  initialState,
}: {
  initialState: CalculatorInitialState;
}) =>
  createStore(
    createReducer({ initialState }),
    composeWithDevTools(applyMiddleware(trackingMiddleware))
  );
